module.exports = __webpack_public_path__ + "img/word.231ff9fa.png";